<template>
  <LazyHydrate when-idle>
    <div class="gridClass mt-6 laptop:my-10">
      <div class="flex flex-col-reverse laptop:flex-row w-full">
        <div class="flex-grow flex flex-col laptop:pe-10">
          <div
            class="flex items-center justify-center text-blue-500 font-bold my-6 laptop:mt-10"
          >
            <NuxtImg
              sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
              width="1000"
              height="1000"
              format="webp"
              class="me-1 w-16"
              quality="100"
              src="/img/icon.webp"
              alt="navatel.ir"
            />
            <h1 class="text-xl laptop:text-3xl">نواتل نســــل نوین ارتباط</h1>
          </div>
          <h2 class="hidden">دانلود نواتل</h2>
          <div class="flex flex-col justify-between flex-grow my-10 mb-24">
            <SectionApp
              :data="item"
              v-for="item in navaApp"
              :key="item.id"
              class="my-4"
            />
          </div>
        </div>
        <div class="w-full laptop:w-1/2">
          <NuxtImg
            sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
            width="1000"
            height="1000"
            format="webp"
            quality="100"
            src="/img/main-page.webp"
            class="w-full"
            alt="ﻧﻮاﺗﻞ، نسل نوین ارتباط"
          />
        </div>
      </div>
    </div>
  </LazyHydrate>
</template>

<script setup>
const { navaApp } = useAppData()

definePageMeta({
  layout: false
})
useHead({

   link: [
    {
      rel: 'canonical',
      href: "https://navatel.ir/downloads/"
    }
  ]
})
</script>
